/* 🤖 this file was generated by svg-to-ts */
export const iccIconNavigateTop: {
  name: 'navigate_top';
  data: string;
} = {
  name: 'navigate_top',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12 14.33-3.08 3.08L7.5 16l4.5-4.5 4.5 4.5-1.42 1.41L12 14.33Z" fill="currentColor"/><path d="m12 9.33-3.08 3.08L7.5 11 12 6.5l4.5 4.5-1.42 1.41L12 9.33Z" fill="currentColor"/><path d="M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10Zm0-18c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8Z" fill="currentColor"/></svg>`
};
